module.exports = __webpack_public_path__ + "media/images/logo_oms-inverse-2b503df1f84ce42054fa10cb76502678.png";